  import { useDeleteHttp } from "../../../../hooks/http/http.hook";

export function useRemoveProposalSocialHttp() {
  return useDeleteHttp<null, null>({
    path: "/brand/campaigns/proposals/:proposalId/socials/:proposalSocialId",
  });
}
